import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=5464f59d&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5464f59d')) {
      api.createRecord('5464f59d', component.options)
    } else {
      api.reload('5464f59d', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=5464f59d&", function () {
      api.rerender('5464f59d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GX7t4fEGPVG4/JS/comp/ErrorMessage.vue"
export default component.exports